// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2iWHX","left":"InfoRow_left__OC-0j"};